
/* START_TEMPLATE */
define('hbs!app/templates/page_alert',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var lambda=this.lambda, escapeExpression=this.escapeExpression;
  return "<div class=\"at-page-alert-wrapper\">\n            <div class=\"at-alert alert\">\n                <span class=\"alert-content\">"
    + escapeExpression(lambda(depth0, depth0))
    + "</span>\n                <a href=\"javascript:void(0);\" class=\"glyphicons glyphicons-remove at-dismiss\"></a>\n            </div>\n        </div>";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "<div class=\"at-page-alert\">";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.alerts : depth0), {"name":"each","hash":{},"fn":this.program(1, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>\n";
}});
Handlebars.registerPartial('app/templates/page_alert', t);
return t;
});
/* END_TEMPLATE */
;
